export const createToConnectionRequestModel = (set) => ({
  toConnectionRequestModel: null,
  selectedToConnectionRequestIds: [],
  bulkEditType: 'hotels',
  setToConnectionRequestModel: (model) =>
    set({ toConnectionRequestModel: model }),
  clearToConnectionRequestModel: () => set({ toConnectionRequestModel: null }),
  setSelectedToConnectionRequestIds: (ids) =>
    set({ selectedToConnectionRequestIds: ids }),
  clearSelectedToConnectionRequestIds: () =>
    set({ selectedToConnectionRequestIds: [] }),
  setBulkEditType: (type) => set({ bulkEditType: type }),
});
